import { AxiosResponse } from "axios";
import { TFunction } from "react-i18next";
import { Flash } from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { apiOrganization } from "../../../../../../../../../services/Api/Organization/apiOrganization";
import { InvoiceApi } from "../../../../../../../../../services/Api/Organization/types";

const downloadInvoiceFileToPc = async (downloadData: () => Promise<AxiosResponse<any, any>>, fileName: string) => {
	const res = await downloadData();
	const url = window.URL.createObjectURL(new Blob([res.data]));
	const link = document.createElement("a");
	link.href = url;
	link.setAttribute("download", fileName);
	document.body.appendChild(link);
	link.click();
};

export const exportEInvoice = async (
	invoice: InvoiceApi,
	t: TFunction,
	addFlash: (_: Flash) => void
): Promise<void> => {
	try {
		const downloadData = () => apiOrganization.getEInvoice(invoice.id);
		const fileName = `${t(`modules.invoice.field.e-invoice.title`)}_${invoice.dates.issue_date}.xml`;
		await downloadInvoiceFileToPc(downloadData, fileName);
	} catch (err) {
		handleError.alert(err, addFlash);
	}
};
